module.exports = __webpack_public_path__ + "cancellara-dist/img/promarsa.dd7ac8cd.png";